import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Button, Table, Pagination } from "antd";
import { useModel } from "../../../models";
import { goPage } from "../../layout/pageDefinition";
import moment from "moment";
import { DICT_KEY, getDictNameByCode, getModel, setModel, ENV } from "../../../utils/constants";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const columns = [
    {
        title: '序号',
        width: 50,
        // render: (_, __, index) => <span>{index + 1}</span>,
        render: (value, row, index) => {
            return {
                children: row.index,
                props: {
                    rowSpan: row.rowSpanNum
                },
            };
        }
    },

    {
        title: '结算日期',
        width: 120,
        dataIndex: 'settlementDate',
        render: (value, row, index) => {
            return {
                children: value ? moment(value).format("YYYY-MM-DD") : "",
                props: {
                    rowSpan: row.rowSpanNum
                },
            };
        }
    },
    {
        title: '采购金额合计',
        width: 120,
        dataIndex: 'total',
        align: 'left',
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row.rowSpanNum
                },
            };
        }
    },
    {
        title: '供应商名称',
        width: 120,
        dataIndex: 'supplierName',
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row.rowSpanNum
                },
            };
        }
    },
    {
        title: '商品编号',
        width: 120,
        dataIndex: 'materialCode',
    },
    {
        title: '商品名称',
        width: 120,
        dataIndex: 'materialName',
    },

    {
        title: '进货价',
        width: 100,
        dataIndex: 'purchasePrice',
    },
    {
        title: '采购数量',
        width: 100,
        dataIndex: 'purchaseNum',
    },
    {
        title: '采购金额',
        width: 100,
        dataIndex: 'purchaseAmount',
    },
    {
        title: '采购类型',
        width: 100,
        dataIndex: 'orderTypeName',
    },
    {
        title: '发票类型',
        width: 100,
        dataIndex: 'inventoryTypeName',
    },
];


export default function () {
    const [
        { searchParam, customerSaleList, documentStatistic, partDealListSelectedRowKeys, searcnPage },
        { loadListDetail, setPartDealListSelectedRowKeys, exportPartDealList }
    ] = useModel("supplierModel");

    useEffect(() => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { pageSize, pageNum } = searcnPage
        const { supplierName } = searchParam;
        let data = {
            startTime,
            endTime,
            pageSize,
            pageNum,
            supplierName,
        }
        loadListDetail({ showMsg: true, data })
    }, []);

    const history = useHistory();

    const onExport = () => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { pageSize, pageNum } = searcnPage
        const { supplierName } = searchParam;
        let data = {
            startTime,
            endTime,
            supplierName: getDictNameByCode(DICT_KEY.CM_DICT.SUPPLIER, supplierName),
            pageSize,
            pageNum,
        }
        exportPartDealList({ showMsg: true, data });
    }

    const TableHeader = () => {
        return (
            <div style={{ margin: "0 0 8px", display: "flex" }}>
                <div style={{ width: "460px", paddingTop: "6px" }}>
                    <YhAuth resCode={ResourceAuthEnum.STTICS_P_EX}>
                        <Button className="margin-left-8" onClick={onExport}>导出</Button>
                    </YhAuth>
                </div>
                <div className="detail-list-statistic color-primary" style={{ textAlign: "right" }}>
                    <span
                        className="margin-left-16">
                        采购总金额：{!!documentStatistic ? documentStatistic.purchaseAmountTotal : 0.00}
                    </span>
                    <span
                        className="margin-left-16">
                        总采购量：{!!documentStatistic ? documentStatistic.purchaseQuantityTotal : 0}
                    </span>
                </div>
            </div>
        )
    }
    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={customerSaleList}
                bordered
                pagination={false}
                // pagination={{
                //     hideOnSinglePage: false,
                //     showSizeChanger: true,
                //     pageSizeOptions: [2, 15, 50, 100, 200, 500],
                //     defaultCurrent: 1,
                //     defaultPageSize: 15,
                //     pageSize: searcnPage.lineSize,
                //     onChange: (pageNum, pageSize) => {
                //         /*const params = {...searchParam};
                //         params.pageNum = pageNum;
                //         params.pageSize = pageSize;*/
                //         const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
                //         const { supplierName } = searchParam;
                //         const data = { supplierName,startTime, endTime, pageNum, pageSize }
                //         loadListDetail({ showMsg: false, data });
                //     },
                //     total: searcnPage.total,
                //     current: searcnPage.pageNum,
                // }}
                // onRow={record => {
                //     return {
                //         onClick: event => {
                //             console.log("点击行:",event)
                //         },
                //     };
                // }}
                // rowSelection={{
                //     // type: "radio",
                //     onChange: (selectedRowKeys) => {
                //         console.log("点击行:",selectedRowKeys)
                //     },
                // }}
                scroll={{ x: 'max-content', y: 580 }}
            />
            <Pagination
                style={{ marginTop: '10px', textAlign: 'right' }}
                showSizeChanger
                hideOnSinglePage={false}
                pageSizeOptions={[15, 50, 100, 200, 500]}
                defaultCurrent={1}
                defaultPageSize={15}
                onChange={(pageNum, pageSize) => {
                    const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
                    const { supplierName } = searchParam;
                    const data = { supplierName, startTime, endTime, pageNum, pageSize }
                    loadListDetail({ showMsg: false, data });
                }}
                total={searcnPage.total}
                current={searcnPage.pageNum}
            />
        </>
    );
}